import { makeStyles } from '@mui/styles';
import styled from 'styled-components';

const useStyles = makeStyles(() => ({
  root: {
    flexGrow: 1
  },
  card: {
    width: '100%',
    position: 'relative',
    textAlign: 'center',
    marginBottom: 20,
    minWidth: 659,
    minHeight: 350,
  },
  icon: {
    zIndex: 1
  },
  title: {
    fontSize: '1.1em',
    marginBottom: 10
  },
  rootBottom: {
    flexGrow: 1,
    marginTop: 10,
    marginBottom: 10,
    textAlign: 'center'
  },
  gridIconContainer: {
    textAlign: 'end',
    marginBottom: 10
  },
  cardActions: {
    bottom: 0,
    position: 'absolute',
    width: '100%'
  },
  cardActionsLinkContainer: {
    textAlign: 'center',
    width: '100%'
  },
  cardHeader: {
    textAlign: 'center',
    padding: 0,
    backgroundColor: 'rgba(0,0,0,.1)',
  },
  cardHeaderTitle: {
    fontSize: 18,
    color: 'black'
  },
  moreHeaderIcon: {
    paddingTop: '6px',
    paddingLeft: '0px',
    position: 'relative',
    display: 'block',
    float: 'right',
    color: 'black !important'
  },
  dragIndicatorIcon: {
    color: 'black',
    marginRight: 0
  },
  csvLink: {
    color: 'black'
  },
  csvLinOutside: {
    color: 'white',
    width: '30px',
    height: '30px',
    paddingLeft: '10px',
    transform: 'translateY(-2px)'
  },
  csvSpan: {
    paddingBottom: 5,
    transform: 'translateY(-8px)',
    display: 'inline-block'
  },
  dataList: {
    marginBottom: 40
  },
  listItem: {
    paddingBottom: 0,
    paddingTop: 0,
    minHeight: 56
  },
  textListItem: {
    textTransform: 'capitalize'
  },
  menuItem: {
    fontSize: 14
  },
  menuItemText: {
    fontSize: 14,
    paddingLeft: 4,
    paddingTop: 2
  },
  '@global': {
    '.MuiCardHeader-avatar': {
      marginRight: 0
    }
  }
}));

export const Content = styled.div`
  width: 100%;
`;

export const Item = styled.div`
  width: 49.5%;
  float: left;
  margin-right: 0.25%;
`;

export const Header = styled.div`
  width: 100%;
  margin-bottom: 20px;
  text-align: center;
`;

export default useStyles;
